import React, { ReactNode } from "react";

import { Badge } from "primereact/badge";
import { Button } from "primereact/button";
// ??? ReactNode ??? Import auto de vs code

//À mettre dans les Sagas
export interface ColoredMarkerProps {
  children?: ReactNode;
  align?: string;
  // ?? Import auto de VS code
  color: string;
  alert?: boolean | number;
  className?: string;
  lg?: string;
  active?: boolean;
  count?: number;
  bubbleClass?: string;
  tooltip?: string;
  tooltipOptions?: any;
}

export interface ColoredMarkerState {}

const colorToBackground = (color: string) => {
  if (color === "#666") {
    return `rgba(81, 86, 99, 0.24)`;
  }
  const bcolor = color.slice(1, 7);
  return `#${bcolor}1A`; //1A en hex: 10% -> opacité
};

const ColoredMarker = ({
  alert,
  children,
  className,
  color,
  lg,
  active,
  count,
  bubbleClass,
  tooltip,
  tooltipOptions,
}: ColoredMarkerProps) => {
  return (
    <>
      {children !== "" ? (
        <>
          {alert ? (
            <div
              className={
                "marker-container position-relative flex-row" + className
              }
              style={{
                backgroundColor: active ? color : colorToBackground(color),
              }}
            >
              <div className="marker-badge d-flex justify-content-center align-items-center">
                {Number.isInteger(alert) ? alert : "!"}
              </div>
              <p
                className="marker-text mx-auto my-auto"
                style={{ color: active ? "white" : color }}
              >
                {children}
              </p>
            </div>
          ) : (
            <Button
              type="button"
              label={children}
              className={"custom-badge position-relative flex-row " + className}
              style={{
                backgroundColor: active ? color : colorToBackground(color),
                color: active ? "white" : color,
              }}
              tooltip={tooltip}
              tooltipOptions={tooltipOptions}
            >
              {count > 0 && (
                <i
                  className={`${
                    bubbleClass || ""
                  } custom-badge__marker p-overlay-badge p-text-secondary`}
                >
                  <Badge
                    value={count > 0 ? count : null}
                    className={
                      lg !== undefined
                        ? "marker-text m-2 p-overlay-badge"
                        : "marker-text m-auto"
                    }
                  ></Badge>
                </i>
              )}
            </Button>
          )}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default ColoredMarker;
